import { observe } from "selector-observer";

observe(".accordion-btn", {
    add(element) {
        const accordionInfo = element.parentElement.querySelector(".accordion-info");

        element.addEventListener("click", () => { 
            if (accordionInfo.classList.contains('hidden')) {
                accordionInfo.classList.remove('hidden')
                element.setAttribute('aria-expanded', true) 
            } else if (!accordionInfo.classList.contains('hidden')) {
                accordionInfo.classList.add('hidden')
                element.setAttribute('aria-expanded', false)
            }
        });
    }
}); 